const cleanSuggestedTitle = (title: string): string => {
  return title
    .trim()
    .replace(/^["']+/, '')
    .replace(/^\[+/, '')
    .replace(/\]+$/, '')
    .replace(/["']+$/, '')
    .trim();
};

export const normalizeSuggestedTitles = (
  values: readonly unknown[] | string | null | undefined
): string[] | undefined => {
  if (!values) {
    return undefined;
  }

  const rawTitles = Array.isArray(values) ? values : [values];

  const titles = rawTitles
    .filter((title): title is string => typeof title === 'string')
    .map(cleanSuggestedTitle)
    .filter((title) => title !== '');

  return titles.length > 0 ? titles : undefined;
};

export type SuggestedTitleSource = {
  taxonomyTitles?: string | readonly (string | null)[] | null;
  suggestedTitles?: string[];
};

export const resolveSuggestedTitles = (
  data: SuggestedTitleSource
): string[] | undefined => {
  const hasTaxonomyTitles =
    data.taxonomyTitles !== undefined && data.taxonomyTitles !== null;
  const source = hasTaxonomyTitles ? data.taxonomyTitles : data.suggestedTitles;
  return normalizeSuggestedTitles(source);
};
